/**
 * Lista fixa de contas exibidas no campo "Conta" do modal Devolver Prévia.
 * accountId é o identificador numérico enviado à API POST /api/previaapproval/return/draft.
 */
export const RETURN_PREVIEW_ACCOUNT_OPTIONS = [
  { label: 'Faturamento', value: 'faturamento', accountId: 1 },
  { label: 'Consumo', value: 'consumo', accountId: 2 },
  { label: 'Pessoal', value: 'pessoal', accountId: 3 },
  { label: 'Depreciação', value: 'depreciacao', accountId: 4 },
  { label: 'Outras Despesas', value: 'outras_despesas', accountId: 5 },
  { label: 'Bonificação', value: 'bonificação', accountId: 6 }
] as const

/**
 * Retorna o accountId (número) da opção para o value informado.
 * Usado ao enviar rascunho para POST /api/previaapproval/return/draft.
 */
export function getAccountIdFromValue(value: string | null | undefined): number | null {
  if (!value || typeof value !== 'string') return null
  const found = RETURN_PREVIEW_ACCOUNT_OPTIONS.find((opt) => opt.value === value.trim())
  return found ? found.accountId : null
}

/**
 * Retorna o value da opção que corresponde ao nome da conta do item (ex.: da linha do grid).
 * Usado para pré-preencher "Conta" quando não há draft.
 */
export function getAccountValueFromAccountName(accountName: string | null | undefined): string {
  if (!accountName || typeof accountName !== 'string') return ''
  const normalized = accountName.trim()
  const found = RETURN_PREVIEW_ACCOUNT_OPTIONS.find((opt) => opt.label.toLowerCase() === normalized.toLowerCase())
  return found ? found.value : ''
}

/**
 * Retorna o value da opção para exibição no Select quando os dados vêm da API (items com accountId).
 */
export function getAccountValueFromAccountId(accountId: number | null | undefined): string {
  if (accountId == null) return ''
  const found = RETURN_PREVIEW_ACCOUNT_OPTIONS.find((opt) => opt.accountId === accountId)
  return found ? found.value : ''
}

/**
 * Retorna o label da opção para exibição (ex.: "Faturamento") quando os dados vêm da API (items com accountId).
 */
export function getAccountLabelFromAccountId(accountId: number | null | undefined): string {
  if (accountId == null) return ''
  const found = RETURN_PREVIEW_ACCOUNT_OPTIONS.find((opt) => opt.accountId === accountId)
  return found ? found.label : ''
}
